
import * as tinyCookie from "tiny-cookie";
import Vue from "vue";

export default Vue.extend({
  name: "Cookie",
  props: {
    debug: {
      type: Boolean,
      default: false,
    },

    // slideFromBottom, slideFromTop, fade
    transitionName: {
      type: String,
      default: "slideFromBottom",
    },

    showPostponeButton: {
      type: Boolean,
      default: false,
    },

    forceCookies: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      supportsLocalStorage: true,
      isOpen: false,
      cookieCategories: [
        { id: 'essential', name: 'Essential', description: 'Required for website functionality.' },
        { id: 'analytics', name: 'Analytics', description: 'Helps us understand website usage.' },
        { id: 'marketing', name: 'Marketing', description: 'Used for targeted advertising.' },
      ],
      consentPreferences: {
        essential: true,
        analytics: false,
        marketing: false,
      },
    };
  },
  mounted() {
    this.checkLocalStorageFunctionality();
    this.init();
  },
  methods: {
    init() {
      
      console.log(this.consentPreferences);

      let haveConsent =this.loadConsent();

      if (!haveConsent) {
        this.consentPreferences = {
          essential: true,
          analytics: false,
          marketing: false,
        };
        this.isOpen = true;
      } else {
        this.applyConsent();
      }

      // TODO: check if anything is catching this
      //this.$emit("status", visitedType);
    },
    toggleConsent(category) {
      if (category.id === 'essential') {
        this.consentPreferences.essential = true; // Essential cookies are always accepted
      } else {
        this.consentPreferences[category.id] = !this.consentPreferences[category.id];
      }
    },
    applyConsent() {

      function gtag() {
        // just in case the dataLayer is not defined yet
        window.dataLayer = window.dataLayer || []; 
        dataLayer.push(arguments); 
      }

      gtag('consent', 'update', {
        ad_user_data: this.consentPreferences.marketing ? 'granted' : 'denied',
        ad_personalization: this.consentPreferences.marketing ? 'granted' : 'denied',
        ad_storage: this.consentPreferences.marketing ? 'granted' : 'denied',
        analytics_storage: this.consentPreferences.analytics ? 'granted' : 'denied'
      });
      // Load Tag Manager script.
      var gtmScript = document.createElement('script');
      gtmScript.async = true;
      gtmScript.src = 'https://www.googletagmanager.com/gtm.js?id=GTM-WKGFHX7F';

      var firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode.insertBefore(gtmScript,firstScript);
    },
    acceptAll() {
      this.cookieCategories.forEach(category => {
        this.consentPreferences[category.id] = true;
      });
      this.saveConsent();
    },
    savePreferences() {
      this.consentPreferences.essential = true; // Essential cookies are always accepted
      this.saveConsent();
    },
    saveConsent() {
      if (this.supportsLocalStorage) {
        localStorage.setItem(`bikeflights-consent-preferences`, JSON.stringify(this.consentPreferences));
      } else {
        tinyCookie.set(`bikeflights-consent-preferences`, JSON.stringify(this.consentPreferences));
      }
      this.applyConsent();
      this.isOpen = false;
      this.$emit("clicked-accept");
    },
    loadConsent() {
      if (this.supportsLocalStorage) {
        const consent = localStorage.getItem(`bikeflights-consent-preferences`);
        if (consent) {
          this.consentPreferences = JSON.parse(consent);
          return true;
        }
        return false;
      } else {
        const consent = tinyCookie.get(`bikeflights-consent-preferences`);
        if (consent) {
          this.consentPreferences = JSON.parse(consent);
          return true;
        } 
        return false;
      }
    },
    checkLocalStorageFunctionality() {
      if (this.forceCookies) {
        this.supportsLocalStorage = false;
        return;
      }
      // Check for availability of localStorage
      try {
        const test = "__bikeflights-consent-check-localStorage";
        window.localStorage.setItem(test, test);
        window.localStorage.removeItem(test);
      } catch (e) {
        console.error(
          "Local storage is not supported, falling back to cookie use"
        );
        this.supportsLocalStorage = false;
      }
    },
  },
});
